import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { parseDateTime } from '../../date-time';
import './InfoDialog.scss';

const InfoDialog = ({ data, onClose }) => {
    const createdAt = data ? parseDateTime(data.createdOn) : '';
    const modifiedBy = data?.modifiedBy || 'NA';
    const modifiedAt = data?.modifiedOn ? parseDateTime(data.modifiedOn) : 'NA';

    return (
        <Dialog
            visible={!!data}
            header="Request Info"
            onHide={onClose}
            className="info-dialog"
        >
            <div>
                <p>
                    <span className="info-dialog__label">Created By : </span>
                    {data?.createdBy}
                </p>
                <Divider />
                <p>
                    <span className="info-dialog__label">Created At : </span>
                    {createdAt}
                </p>
                <Divider />
                <p>
                    <span className="info-dialog__label">Modified By : </span>
                    {modifiedBy}
                </p>
                <Divider />
                <p>
                    <span className="info-dialog__label">Modified At : </span>
                    {modifiedAt}
                </p>
                <Divider />
            </div>
        </Dialog>
    );
};

export default InfoDialog;
